import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function MainActivities() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      <legend>{t("Main Activities")}</legend>
      <input
        className="form-control"
        name="mainActivities"
        onChange={onChange}
        value={searchObject.mainActivities || ""}
      />
    </fieldset>
  );
}
